import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { startLoading, endLoading } from '../../actions/loadingActions';
import { addAddress, updateAddress } from '../../actions';
import { addAddressToClient } from '../../actions/admin';
import { renderInput } from './newcaso/Fields'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import _ from 'lodash';

class AddressForm extends Component {
    componentDidUpdate(prevProps, prevState){
    }
    onSubmit(data){
        if(this.props.selectedAddress){
            this.props.updateAddress(data, data.id);
            this.props.toggler()
        }else {
            data.country = "ES";
            if(!this.props.clientId){
                this.props.addAddress(data, this.props.clientId);
            } else {
                this.props.addAddressToClient(data, this.props.clientId);
            }
            this.props.startLoading();
            this.props.toggler()
        }
    }
    render(){
        const { handleSubmit } = this.props;

        return(

                <Modal className="modal-lg modal-dialog-centered" isOpen={this.props.show} toggle={this.props.toggler}>
                    <ModalHeader toggle={this.props.toggler}>Añadir nueva dirección</ModalHeader>
                    <ModalBody>
                        <form ref="formAddress" className="modal-form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                            <div className="form-row">
                            <Field
                                name="name"
                                type="text"
                                label="Nombre"
                                col="col-md-12"
                                component={renderInput}
                            />
                            <Field
                                name="address"
                                type="text"
                                label="Dirección"
                                col="col-md-12"
                                component={renderInput}
                            />
                            <Field
                                name="city"
                                type="text"
                                label="Ciudad"
                                col="col-md-6"
                                component={renderInput}
                            />
                            <Field
                                name="region"
                                type="text"
                                label="Región"
                                col="col-md-6"
                                component={renderInput}
                            />
                            <Field
                                name="postal"
                                type="text"
                                label="Código postal"
                                col="col-md-6"
                                component={renderInput}
                            />
                            <Field
                                name="phone"
                                type="text"
                                label="Teléfono"
                                col="col-md-6"
                                component={renderInput}
                            />
                            </div>
                            <div className="modal-form-actions">
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="link" onClick={this.props.toggler}>Cancelar</Button>
                        <Button color="primary" onClick={handleSubmit(this.onSubmit.bind(this))}>Guardar</Button>{' '}
                    </ModalFooter>
                </Modal>

        )
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        initialValues: ownProps.selectedAddress
    };
}

AddressForm = reduxForm({
    enableReinitialize: true,
    form: 'addAddress',
})(AddressForm);



export default AddressForm = connect(mapStateToProps, {
    addAddress,
    updateAddress,
    startLoading,
    endLoading,
    addAddressToClient
})(AddressForm);


// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/AddressForm.jsx